import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { sampleApps } from './AppStore';
import './appdetail.css';

export default function AppDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [app, setApp] = useState(null);
  const [loading, setLoading] = useState(true);
  const [cycle, setCycle] = useState('monthly');

  useEffect(() => {
    async function fetchApp() {
      const snap = await getDoc(doc(db, 'lexApps', id));
      if (snap.exists()) {
        setApp({ id: snap.id, ...snap.data() });
      } else {
        const found = sampleApps.find(a => a.id === id);
        if (found) setApp(found);
        else navigate(-1);
      }
      setLoading(false);
    }
    fetchApp();
  }, [id, navigate]);

  if (loading) return <div className="appdetail-loading">Loading…</div>;
  if (!app) return null;

  const { name, tagline, imageUrl, link, pricing } = app;
  const price = pricing.model === 'one-time'
    ? pricing.oneTimePrice
    : cycle === 'monthly'
      ? pricing.monthlyPrice
      : pricing.yearlyPrice;

  const handleCheckout = async () => {
    const stripe = await loadStripe('pk_live_XXX');
    const priceId = pricing.model === 'one-time'
      ? pricing.stripeOneTimePriceId
      : cycle === 'monthly'
        ? pricing.stripePriceIdMonthly
        : pricing.stripePriceIdYearly;

    await stripe.redirectToCheckout({
      lineItems: [{ price: priceId, quantity: 1 }],
      mode: pricing.model === 'one-time' ? 'payment' : 'subscription',
      successUrl: `${window.location.origin}/success`,
      cancelUrl: window.location.href,
    });
  };

  return (
    <div className="appdetail-page">
      {/* Banner */}
      <div
        className="appdetail-banner full-bleed"
        style={{
          backgroundImage: imageUrl
            ? `linear-gradient(rgba(0,0,0,0.4),rgba(0,0,0,0.4)),url(${imageUrl})`
            : undefined
        }}
      >
        <button className="appdetail-back" onClick={() => navigate(-1)}>
          ← Back
        </button>
        <div className="appdetail-header">
          <h1 className="appdetail-title">{name}</h1>
          <p className="appdetail-tagline">{tagline}</p>
          <button
            className="appdetail-start-btn"
            onClick={() => {
              link.startsWith('http')
                ? window.open(link, '_blank')
                : navigate(link);
            }}
          >
            Start
          </button>
        </div>
      </div>

      {/* Pricing & Checkout */}
      <div className="appdetail-sections full-bleed">
        <section className="partner-card payment-section">
          <div className="payment-info">
            <div className="payment-amount">
              {pricing.currency === 'CNY' ? '¥' : '$'}{price}
              {pricing.model !== 'one-time' && (
                <span className="payment-cycle">
                  /{cycle === 'monthly' ? 'Monthly' : 'Yearly'}
                </span>
              )}
            </div>
            {pricing.model !== 'one-time' && (
              <div className="payment-toggle">
                {['monthly', 'yearly'].map(c => (
                  <button
                    key={c}
                    className={cycle === c ? 'active' : ''}
                    onClick={() => setCycle(c)}
                  >
                    {c === 'monthly' ? 'Monthly' : 'Yearly'}
                  </button>
                ))}
              </div>
            )}
          </div>

          {/* Single-click checkout */}
          <button className="payment-btn" onClick={handleCheckout}>
            {pricing.model === 'one-time' ? 'Buy Now' : 'Subscribe Now'}
          </button>
        </section>
      </div>
    </div>
  );
}
